import React from 'react';
import { makeStyles } from 'react-scale/components/design-system/styles';

export const CorpLookupScratchpad: React.FC<{ url: string }> = props => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <a href={props.url} target="_blank" rel="noopener noreferrer">
        Open external page
      </a>
      <iframe className={classes.iframe} src={props.url} />
    </div>
  );
};

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
  },
  iframe: {
    height: 500,
  },
});
